<div>
    <!-- TyreWidget-->
        <div class="row pt-3 pb-3">
            <div class="col-md-3 col1" align="center">
                <h2>{{tyreYearly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total year to date</h5>
                <p>___________________</p>
                <font *ngIf="tyreYearly == 0">NO RECORD FOR YEAR TO DATE</font>
                <font *ngIf="tyreYearly > 0">TOTAL TYRE COST FOR YEAR TO DATE</font>
            </div>
        
            <div class="col-md-3 col2" align="center">
                <h2>{{tyreMonthly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total this month</h5>
                <p>___________________</p>
                <font *ngIf="tyreMonthly == 0">NO RECORD FOR THE CURRENT MONTH</font>
                <font *ngIf="tyreMonthly > 0">TOTAL TYRE COST FOR THE CURRENT MONTH</font>
            </div>
        
            <div class="col-md-3 col3" align="center">
                <h2>{{tyreWeekly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total this week</h5>
                <p>___________________</p>
                <font *ngIf="tyreWeekly == 0">NO RECORD FOR THE CURRENT WEEK</font>
                <font *ngIf="tyreWeekly > 0">TOTAL TYRE COST FOR THE CURRENT WEEK</font>
            </div>
        
            <div class="col-md-3 col4" align="center">
                <h2>{{tyreRecentCost | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Latest Tyre Cost</h5>
                <p>___________________</p>
                <font *ngIf="tyreRecentCost==0">NO RECENT RECORD</font>
                <font *ngIf="tyreRecentCost!=0"> TYRE FOR {{tyreRecentRego}} ON
                    {{ (tyreRecentDate !== null) && (tyreRecentDate !== "NONE") ? (tyreRecentDate | date: 'dd MMM yyyy') : "UNRECORDED DATE"  }}</font>
            </div>
        </div>
    
    <!-- Feature Menu Icons-->
    <div class="row">
        <div class="col-md-12">
            <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" placement="bottom" ngbTooltip="Add New Tyre" (click)="openTyreModal(null)">
                <span class="sr-only">Add</span>
                <i class="fa fa-lg fa-plus"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
            </button>
            
            <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print(prefixTyre)" placement="bottom" [disabled]="count < 1" ngbTooltip="Print List">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
            </button>

            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="count < 1"
                    placement="bottom" ngbTooltip="Export List">
                    <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="tyre_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                    <a (click)="tyre_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                    <a (click)="tyre_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>

            <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"(click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                <i class="fa fa-lg fa-filter"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
            </button>

            <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                <i class="fa fa-lg fa-toggle-right"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
            </button>
            
            <div class="btn-group mb-1">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    placement="bottom" ngbTooltip="Show/Hide Columns">
                    <span class="sr-only">Toggle Dropdown</span>
                    <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                </button>
                <div class="dropdown-menu fs-12" style="width: 150px;">
                    <div class="col-md-12 mb-3 fs-12">
                        <input type="checkbox" [(ngModel)]="showDate">&nbsp;Date Done<br />
                        <input type="checkbox" [(ngModel)]="showRego">&nbsp;REGO<br />
                        <input type="checkbox" [(ngModel)]="showFleetID">&nbsp;Fleet ID<br />
                        <input type="checkbox" [(ngModel)]="showSupplier">&nbsp;Supplier<br /> 
                        <input type="checkbox" [(ngModel)]="showCost">&nbsp;Cost<br />
                        <input type="checkbox" [(ngModel)]="showReceiptNo">&nbsp;Receipt No<br />
                        <input type="checkbox" [(ngModel)]="showFile">&nbsp;File<br />
                    </div>
                </div>
            </div>

            <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
                <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                ngxDaterangepickerMd
                [locale]="locale"
                startKey="start"
                endKey="end"
                [showWeekNumbers]="true"
                [showDropdowns]="true"
                [(ngModel)]="tyreDateRange"
                (ngModelChange)="processTyreDateRange($event)"
                name="daterange" 
                [autoApply]="true"
                opens="left"
                drops="down"
                
                />
            </span>
           
            <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                    <option value="7">Last 7 days</option>
                    <option value="14">Last 14 days</option>
                    <option value="30">Last 30 days</option>
                    <option value="90">Last 90 days</option>
                    <option value="all">All Dates</option>
                    <option value="range">Custom date range</option>
            </select>
            
        </div>
    </div><!-- End of Feature Menu Icons-->

    <br *ngIf="showFilters" />
    <!-- Search Tyre List -->
    <div class="row pt-0">
        <div class="col-md-8">
            <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                <div class="card-header border-0 text-muted">
                    <h5 class="mb-0">Search Tyre Cost List:</h5>
                    <div class="widget-controls"> 
                        <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                    </div>  
                </div>
                <div class="card-block card-header pt-0 widget-body">
                    <div class="row">
                        <div class="col-md-4">
                                <label>REGO:</label> 
                                <input type="text" class="form-control form-control-sm" (keyup)="updateFilter(prefixTyre)" [(ngModel)]="filterTyreRego">
                        </div>
                        <div class="col-md-4">
                                <label>Supplier:</label> 
                                <select placeholder="Select" class="form-control form-control-sm" [(ngModel)]="filterTyreProvider" (change)="updateFilter(prefixTyre)"> 
                                    <option selected disabled>Select..</option>
                                    <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                                </select>
                        </div>
                    </div>   <br />
                        
                    <div class="row" *ngIf="!isFilterEmpty">
                        <div class="col-md-12">
                            <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                    <span >Reset Filters</span>
                            </button> &nbsp;
                        </div>
                            
                    </div>                                  
                </div>
            </div> 
        </div>
    </div><!-- End of Search Tyre List -->

    <br *ngIf="showFilters" />
    <ngx-loading [show]="loadingIndicator2"></ngx-loading>
    <div class="row pt-3">
        <!-- TYRES TABLE -->
        <div  [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'" align="left">
            <span>
                Items: <span style="color: rgb(23, 98, 141);">{{ (totalTyre !== null) ?   (totalTyre) : "0"}}</span>   |  
                Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageTyreAmount  && averageTyreAmount !== null) ?   '$' + (averageTyreAmount | number:'1.2-2') : "0.00"}}</span> |
                Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalTyreAmount  && totalTyreAmount !== null) ?   '$' + (totalTyreAmount | number:'1.2-2') : "0.00"}}</span>
            </span>
            <ngx-datatable
                [loadingIndicator]="loadingIndicator2"
                class="material"
                [rows]="tyres"
                [columnMode]="'force'"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="30"
                [selected]="selected"
                [selectionType]="'single'"
                (activate)="onActivate2($event)"
                (select)='onSelect2($event)'
                [scrollbarH]="true"
                >

                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="80">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div>
                            <a container="body" placement="top" title="Edit Tyre" (click)="openTyreModal(row)"><i
                                    class="fa fa-lg fa-pencil"></i></a>
                            <a (click)="openDeleteTyreModal(row)" placement="right" title="Delete Tyre"><i
                                    class="fa fa-lg fa-trash"></i></a>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date Done" prop="date_done" headerClass="header" *ngIf="showDate" [width]="150">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                                {{ (value !== null) ? (value | date: 'dd MMM yyyy') : "No Data"  }}
                        </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="REGO" prop="rego" headerClass="header" *ngIf="showRego" [width]="150">
                </ngx-datatable-column>
                <ngx-datatable-column name="Fleet ID" prop="fleet_id_num" headerClass="header" *ngIf="showFleetID" [width]="150">
                </ngx-datatable-column>
                <ngx-datatable-column name="Supplier" prop="provider" headerClass="header" *ngIf="showSupplier" [width]="150">
                    </ngx-datatable-column>
                <ngx-datatable-column name="Cost" prop="cost" headerClass="header-currency" *ngIf="showCost" [width]="150">
¡                   <ng-template let-value="value" ngx-datatable-cell-template>
                        <div align="right" style="padding-right:20px"> {{ (value !== null) ?  (value | currency:'USD':'symbol') : "No Price"}}</div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Receipt No" prop="receipt_no" headerClass="header" *ngIf="showReceiptNo" [width]="150">
                </ngx-datatable-column>
                <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="300" *ngIf="showFile">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a href="{{fileStoragePath}}/tyre/{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div><!-- END OF TYRES TABLE -->

        <!-- TYRE DETAILS SIDEBAR -->
        <div class="col-md-4" *ngIf="showSidebar">
            <div widget class="card border-0 box-shadow selected-column">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0">Tyre Details:</h5>
                </div>
                <div class="card-body pt-0 widget-body">
                    <ul>
                        <div *ngFor='let sel of selected, let i = index'>
                            <div class="col-md-12 details">
                                Date: <strong>{{ sel.date_done | date: 'dd MMM yyyy' }}</strong>
                                <hr />
                                Fleet: <strong>{{sel.fleet_id_num}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                Rego: <strong>{{sel.rego}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                Driver: <strong >{{ (sel.driver !== null) ?  sel.driver : "No Data Recorded"}}</strong><br />
                                <hr />
                        
                                Company Name: <strong>{{sel.provider}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            
                                <hr />
                                Tyre Description: <strong>{{sel.tyre_description}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                Fault: <strong>{{sel.fault}}</strong>

                                <hr />
                                Cost: <strong>${{ sel.cost | number:'1.2-2'}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                Receipt No: <strong>{{sel.receipt_no}}</strong>
                            </div> <br>
                            <div class="col-md-12">
                                <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openTyreModal(sel)">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                            class="fa fa-lg fa-pencil"></i></span>
                                    Edit
                                </button> &nbsp;
                                <button type="button" class="btn btn-sm btn-danger mb-1"
                                    (click)="openDeleteTyreModal(sel)">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                            class="fa fa-lg fa-trash"></i></span>
                                    Delete
                                </button>
                                &nbsp;
                                <button *ngIf="!!sel.file" type="button" class="btn btn-sm btn-secondary mb-1">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                        class="fa fa-lg fa-file"></i></span>&nbsp;
                                    <a  href="{{fileStoragePath}}/tyre/{{sel.file}}" target="_new" style="text-decoration: none; color: white;">View File</a>
                                </button>
                            </div>
                        </div>
                        <li *ngIf="!selected.length">No Selections</li>
                    </ul>
                </div>
            </div>
        </div><!-- END OF TYRE DETAILS SIDEBAR  -->
    </div> 
</div>
    
    
    <!-- START OF ADD TYRE FORM -->
    <ng-template #modalTyre let-close="close">
        <div class="modal-header">
                <h5 class="modal-title" *ngIf="isEditMode==false">Add New Tyre Cost</h5>
                <h5 class="modal-title" *ngIf="isEditMode==true">Edit Tyre</h5>
                    <button type="button" class="close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="tyreForm" novalidate (ngSubmit)="onSubmitTyre(tyreForm.value)">
            <div class="modal-body">
                <div class="row pt-0">
                    <div class="form-group col-md-4" >
                        <h6>Date<span class="text-danger">*</span> :</h6>
                        <input formControlName="date_done" class="form-control form-control-sm" type="date" required>
                        <div *ngIf="tyreForm.controls.date_done.touched">
                            <div *ngIf="tyreForm.controls.date_done.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4"> 
                       <h6>Time :</h6>
                        <ngb-timepicker formControlName="time_string" [meridian]="true"></ngb-timepicker>
                      <!--  <div *ngIf="tyreForm.controls.time_string.touched">
                            <div *ngIf="tyreForm.controls.time_string.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>  
                    -->
                    </div>

                    <div class="form-group col-md-4" >
                        <h6>Description<span class="text-danger">*</span> :</h6>
                        <input formControlName="tyre_description" class="form-control form-control-sm" type="text" required>
                        <div *ngIf="tyreForm.controls.tyre_description.touched">
                            <div *ngIf="tyreForm.controls.tyre_description.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4" >
                        <h6>Cost<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                            <input formControlName="cost" class="form-control form-control-sm" type="text" required>
                        </div>
                        <div *ngIf="tyreForm.controls.cost.touched">
                            <div *ngIf="tyreForm.controls.cost.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="tyreForm.controls.cost.errors?.pattern && !isCost() ">
                                <small class="text-danger">Cost must have a valid currency value.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4" >
                        <h6>Hours<span class="text-danger">*</span> :</h6>
                        <div class=input-group>
                            <input formControlName="hours" class="form-control form-control-sm" type="text" required>
                        </div>
                        <div *ngIf="tyreForm.controls.hours.touched">
                            <div *ngIf="tyreForm.controls.hours.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="tyreForm.controls.hours.errors?.pattern && !isHour() ">
                                <small class="text-danger">This field requires numeric values only.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <h6>Driver:</h6>
                        <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <h6>Fleet<span class="text-danger">*</span> :</h6>
                        <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required>
                            <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                            <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}} ({{fl.fleet_id_num}})</option>
                        </select>
                        <div *ngIf="tyreForm.controls.fleet_id.touched">
                            <div *ngIf="tyreForm.controls.fleet_id.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class=" form-group col-md-4">
                        <h6>Provider<span class="text-danger">*</span> :</h6>
                        <select class="form-control form-control-sm" placeholder="Select" formControlName="provider_id" required>
                            <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                            <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                        </select>
                        <div *ngIf="tyreForm.controls.provider_id.touched">
                            <div *ngIf="tyreForm.controls.provider_id.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4" >
                        <h6>Odometer<span class="text-danger">*</span> :</h6>
                        <div class=input-group>
                        <input formControlName="mileage" class="form-control form-control-sm" type="text" required>
                        </div>
                        <div *ngIf="tyreForm.controls.mileage.touched">
                            <div *ngIf="tyreForm.controls.mileage.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="tyreForm.controls.mileage.errors?.pattern && !isMileage() ">
                                <small class="text-danger">This field requires numeric values only.</small>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group col-md-4" >
                        <h6>Fault:</h6>
                        <input formControlName="fault" class="form-control form-control-sm" type="text">
                      <!--  <div *ngIf="tyreForm.controls.fault.touched">
                            <div *ngIf="tyreForm.controls.fault.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div> -->
                    </div>
                    <div class="form-group col-md-4" >
                        <h6>Receipt#<span class="text-danger">*</span>:</h6>
                        <input formControlName="receipt_no" class="form-control form-control-sm" type="text" required>
                        <div *ngIf="tyreForm.controls.receipt_no.touched">
                            <div *ngIf="tyreForm.controls.receipt_no.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="tyreForm.controls.receipt_no.errors?.pattern ">
                                <small class="text-danger">This field requires numeric values only.</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group" *ngIf ="(fileExists==true)">
                            <h6>File:</h6>
                            <label>{{tyre?.file}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile(prefixTyre)">Remove File</button>
                        </div>
                        <div class="form-group" *ngIf ="(fileExists==false)">
                            <h6>File :</h6>
                            <app-file-uploader (passFile)="getFile($event, prefixTyre)"></app-file-uploader>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!tyreForm.valid || spinner == true">Save</button>
                <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!tyreForm.valid || spinner == true">Save Changes</button>
    
                <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus >Cancel</button>
            </div>
        </form>
        </ng-template>
    <!-- END OF MODAL ADD TYRE FORM -->
    
    <!-- START OF DELETE TYRE FORM -->
    <ng-template #modalDeleteTyre let-close="close">
        <div class="modal-header">
            <h5 class="modal-title">Delete Tyre Cost</h5>
            <button type="button" class="close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body bg-gray">
            <div class="row pt-0">
                <div class="col-md-12">
                    Do you really want to delete this tyre cost?
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="button" class="btn btn-sm btn-danger"  (click)="deleteTyre(tyre)" [disabled]="spinner == true">Delete</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
        </div>
    </ng-template>
    <!-- END OF MODAL DELETE TYRE FORM -->
    
    <!-- TYRE -->
<div id="print-section-tyre" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showDate">DATE DONE</th>
            <th align="left" *ngIf="showRego">REGO</th>
            <th align="left" *ngIf="showFleetID">FLEET ID</th>
            <th align="left" *ngIf="showSupplier">SUPPLIER</th>
            <th align="left" *ngIf="showCost">COST</th>
            <th align="left" *ngIf="showReceiptNo">RECEIPT NO</th>
            <th align="left" *ngIf="showFile">FILE</th>
        </tr>
        <tr *ngFor="let row of tyres">
            <td *ngIf="showDate">{{ (row.date_done !== null) ? (row.date_done | date: 'dd MMM yyyy') : ""  }}</td>
            <td *ngIf="showRego">{{row.rego}}</td>
            <td *ngIf="showFleetID">{{row.fleet_id_num}}</td>
            <td *ngIf="showSupplier">{{row.provider}}</td>
            <td *ngIf="showCost">{{row.cost | currency:'USD':'symbol'}}</td>
            <td *ngIf="showSupplier">{{row.receipt_no}}</td>
            <td *ngIf="showFile">{{row.file}}</td>
        </tr>
    </table>
</div>


    
